/* eslint-disable import/order */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import classNames from 'classnames';
import { Divider, theme } from 'antd';
import { FormattedMessage } from 'react-intl';
import { Link, useLocation } from 'react-router';
import { useDispatch } from 'react-redux';

import DisplayNameFormatter from 'components/DisplayNameFormatter';
import { useSelector } from 'hooks/useSelector';
import { Dropdown } from 'ui/base';
import { getCurrentUserAdditionalData, isImpersonatingUser } from 'modules/users/selectors/currentUser';

import { signOut } from 'modules/auth/actions';
import { getCurrentRoute } from 'services/RouterUtils';
import { PATH, ROUTES } from 'constants/RoutesConstants';

import UserPicture from './UserPicture';
import DropdownHeader from './DropdownHeader';

import { overlayStyle } from 'ui/menus/style';
import * as stylesHeader from 'ui/layout/header/Header.module.less';

const LOGIN_ITEMS = [
  {
    key: ROUTES.PROFILE,
    icon: <i className="fb-icon--profil" />,
    label: (
      <Link className="d-block" to={PATH.PROFILE.path} data-cy="profile_Navigation_Btn">
        <FormattedMessage id="profile" defaultMessage="Profile" />
      </Link>
    ),
  },
  {
    key: 'logout',
    icon: <i className="fb-icon--logout" />,
    label: <FormattedMessage id="logout" defaultMessage="Logout" />,
  },
];

const LoginButton = () => {
  const { token: style } = theme.useToken();
  const contentStyle = {
    minWidth: 200,
    borderRadius: style.borderRadiusLG,
    boxShadow: style.boxShadowSecondary,
    backgroundColor: style.colorBgElevated,
  };

  const location = useLocation();
  const dispatch = useDispatch();
  const impersonate = useSelector(isImpersonatingUser);
  const userData = useSelector(getCurrentUserAdditionalData);
  const haveUser = userData !== undefined;

  const handleMenuOnClick = React.useCallback(
    ({ key: action }) => {
      if (action === 'logout') {
        const { id: userId, token } = userData;
        dispatch(signOut({ userId, token }));
      }
    },
    [dispatch, userData]
  );

  const menu = React.useMemo(
    () => ({
      onClick: handleMenuOnClick,
      selectedKeys: [getCurrentRoute(location.pathname)],
      className: classNames(overlayStyle, 'user-profile'),
      items: [{ key: 'user-profile', type: 'group', children: LOGIN_ITEMS }],
    }),
    [handleMenuOnClick, location.pathname]
  );

  /** @param {React.ReactNode} originalMenu */
  const popupRender = originalMenu => (
    <div className="mt-2" style={contentStyle}>
      <DropdownHeader />
      <Divider className="m-0" />
      {React.cloneElement(originalMenu, {
        style: { boxShadow: 'none' },
      })}
    </div>
  );
  /**/
  return (
    haveUser && (
      <Dropdown menu={menu} popupRender={popupRender}>
        <a
          className={classNames([stylesHeader['header-usernav__link'], stylesHeader['header-usernav__wrapper']])}
          data-cy="user_Navigation_Btn"
        >
          <div className={classNames('lh-1 d-flex align-item-center', { 'flex-column': impersonate })}>
            {!impersonate && <UserPicture {...userData} />}
            {impersonate && (
              <div className="text-xs">
                <FormattedMessage id="page.login.behalf.impersonate" defaultMessage="Impersonate a user" />
              </div>
            )}
            <span className={classNames(stylesHeader['header-usernav__label'], { 'align-self-center': !impersonate })}>
              {userData && <DisplayNameFormatter user={userData} />}
            </span>
          </div>

          <i className={classNames([stylesHeader['header-usernav__caret-down'], 'fb-icon--arrow-down'])} />
        </a>
      </Dropdown>
    )
  );
};

export default LoginButton;
